import { useNavigate } from "react-router-dom";
import { deleteUser } from "./deleteUser";
import { useState } from "react";
import "../styles/AuthViewModal.css";
import { AlertTriangle } from "lucide-react";

const DeleteAccountButton = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleDeleteConfirmed = async () => {
    setLoading(true);
    setErrorMsg("");

    const { success, error } = await deleteUser();

    if (success) {
      navigate("/");
    } else {
      setErrorMsg(error || "Tuntematon virhe");
    }

    setLoading(false);
    setShowModal(false);
  };

  return (
    <div style={{ marginTop: "2rem" }}>
      <button
        onClick={() => setShowModal(true)}
        disabled={loading}
        className="delete-button"
      >
        {loading ? "Poistetaan..." : "Poista tili"}
      </button>

      {errorMsg && <p className="error-text">{errorMsg}</p>}

      {showModal && (
        <div className="auth-modal-backdrop">
          <div className="auth-modal-content">
            <div className="delete-modal-text">
              <AlertTriangle
                color="#f44336"
                size={32}
                style={{ marginBottom: "0.5rem" }}
              />
              <div>
                <p>
                  Haluatko varmasti poistaa tilisi? <br />
                  Tämä poistaa kaikki tietosi.
                </p>
              </div>
            </div>

            <div className="delete-modal-buttons">
              <button
                onClick={handleDeleteConfirmed}
                className="confirm-button"
              >
                Kyllä, poista
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="cancel-button"
              >
                Peruuta
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAccountButton;
